// index.js

import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { HashRouter, Route, Routes } from "react-router-dom";

import "./index.css";

import Login from "./Login";
import Home from "./Dashboard/Home/Home";
import Sync from "./Sync";
import Lecture from "./Dashboard/Lecture/Lecture";
import NoPage from "./NoPage";
import Logout from "./Logout";
import NoteMaker from "./Dashboard/Note/NoteMaker";
import Home_ from "./Components/Home";
import Result from "./Dashboard/Result/Result";


import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import userReducer from "./features/Users";

import { PersistGate } from "redux-persist/integration/react";

import ProtectedRoute from "./features/ProtectedRoute";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route index path="/:id" element={<Login />} />
        
        <Route path="/:id/auth/:token" element={<Sync />} />
        <Route
          path="/:id/home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:id/result"
          element={
            <ProtectedRoute>
              <Result />
            </ProtectedRoute>
          }
        />
        <Route path="/:id/lecture" element={<ProtectedRoute><Lecture /></ProtectedRoute>} />
        <Route path="/:id/notemaker" element={<ProtectedRoute><NoteMaker /></ProtectedRoute>} />
        <Route path="/:id/logout" element={<Logout />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </HashRouter>
  );
}

const root = createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);